import { Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { VariantDeliveryMethodEnum } from "./contract/form-template-contract";
import { FormTemplate } from "./form-template.model";
import { QuestionVariant } from "./question-variant.model";
import { Question } from "./question.model";

export class QuestionGroup extends BaseModel {
  id: number;
  name: string;
  description: string;
  questions: Question[];
  questionVariants: QuestionVariant[];
  formTemplateId: number;
  @Type(() => FormTemplate)
  formTemplate: FormTemplate;

  get questionCount(): number {
    return this.questions?.length || 0;
  }

  get questionIds(): number[] {
    return this.questions?.map((q) => q.id) || [];
  }

  get questionOrderNumbers(): number[] {
    if (this.formTemplateId == null) return [];

    const numbers: number[] = [];

    const questions = this.questions ?? [];

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      const variants = (question.questionVariants ?? []).map((variant) => ({
        deliveryMethodId: variant.variantDeliveryMethodId,
        templateQuestion: variant.formTemplateQuestions?.find(
          (entry) => entry.formTemplateSection?.formTemplateId === this.formTemplateId
        ),
      }));
      // Match the primary variant shown in the questionnaire builder.
      const primary =
        variants.find(
          (variant) =>
            variant.templateQuestion &&
            variant.deliveryMethodId === VariantDeliveryMethodEnum.online
        ) ??
        variants.find(
          (variant) =>
            variant.templateQuestion &&
            variant.deliveryMethodId === VariantDeliveryMethodEnum.offline
        );
      const order = primary?.templateQuestion?.order;
      if (typeof order === "number" && Number.isFinite(order)) {
        numbers.push(order);
      }
    }

    return numbers.sort((a, b) => a - b);
  }

  get internalFormTemplateName(): string {
    return this.formTemplate?.internalName || "";
  }
}
